import * as React from "react";

const IconBeneficiario = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      d="M13.49 12.508c0 .83-.667 1.499-1.498 1.499h-8a1.495 1.495 0 0 1-1.5-1.499c0-2.216 1.32-4.106 3.194-4.986.62.522 1.418.847 2.298.847.88 0 1.678-.325 2.297-.847a5.457 5.457 0 0 1 3.21 4.986Zm-2.997-7.576c0-1.336-1.124-2.428-2.493-2.428-1.385 0-2.493 1.092-2.493 2.428 0 1.336 1.124 2.427 2.493 2.427 1.369 0 2.493-1.075 2.493-2.427Z"
      fill="#141938"
    />
  </svg>
);

export default IconBeneficiario;
